
import { mapGetters, mapActions } from 'vuex'
import { header } from '../../customWhiteLabel'

export default {
  data() {
    return {
      parceria: [
        {
          title: 'Parcerias',
          icon: 'mdi-handshake',
          items: [
            {
              title: 'Seja um Parceiro contador',
              icon: 'mdi-square-small',
              to: '/parceiro-contador',
            },
            {
              title: 'Seja uma revenda',
              icon: 'mdi-square-small',
              to: '/seja-uma-revenda',
            },
          ],
        },
      ],
      certificados: [
        {
          title: 'Certificados',
          icon: 'mdi-certificate',
          products: [
            {
              ...this.allCategorias,
            },
          ],
        },
      ],
      header,
    }
  },
  computed: {
    ...mapGetters('product-open', ['allCategorias', 'categoriaRelactedOrg']),
    certificadosData() {
      return this.allCategorias
    },
    isLoading() {
      return (item) => item.products.length === 0
    },
    categorys() {
      if (this.categoriaRelactedOrg.length === 0) {
        return this.allCategorias
      } else {
        return this.categoriaRelactedOrg
      }
    },
  },
  mounted() {
    const screenWidth = this.$vuetify.breakpoint.width >= 1024
    if (screenWidth) {
      this.loadCategory()
    }
  },
  methods: {
    ...mapActions('product-open', [
      'verifyCookieCategoria',
      'fetchCategoriaOpen',
    ]),
    async loadCategory() {
      try {
        if (this.allCategorias.length === 0) {
          await this.fetchCategoriaOpen()
        }
        this.verifyCookieCategoria()
      } catch (error) {
        this.$toast.error('Error: ' + error)
      }
    },
    login() {
      const urlInternoProd = 'https://app.senhadigitalplus.com.br'
      const urlInternoDev = 'https://dev.senhadigitalplus.com.br'

      const url = this.$isDev ? urlInternoDev : urlInternoProd

      window.open(url, '_blank')
    },
  },
}
